import { Sizes } from '@wellesley/uploads/types'
import { type Crop } from 'react-image-crop'

const containerWidth = 560
const cropResponsiveWidth = 1

const getCropSettings = (
  sizes: Sizes,
  cropAspect: number,
  imgMaxHeight: number,
) => {
  const maxRenderWidth = containerWidth
  const maxRenderHeight = imgMaxHeight

  const widthScale = maxRenderWidth / sizes.width
  const heightScale = maxRenderHeight / sizes.height
  const scale = Math.min(1, widthScale, heightScale)

  const renderedWidth = sizes.width * scale
  const renderedHeight = sizes.height * scale

  const maxCropWidth = Math.min(renderedWidth, renderedHeight * cropAspect)

  const desiredWidth = renderedWidth * cropResponsiveWidth
  const desiredHeight = renderedHeight * cropResponsiveWidth

  const cropWidth = Math.min(
    desiredWidth,
    desiredHeight * cropAspect,
    maxCropWidth,
  )
  const cropHeight = cropWidth / cropAspect

  const widthDiff = Math.max(0, containerWidth - renderedWidth)
  const gapX = (renderedWidth - cropWidth) / 2 + widthDiff / 2
  const gapY = (renderedHeight - cropHeight) / 2

  return {
    unit: 'px',
    x: gapX,
    y: gapY,
    width: cropWidth,
    height: cropHeight,
  } as Crop
}

export default getCropSettings
